import { getStore } from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export default action('removeMailItemWithData')(function(data: any) {
    const delayStore = getStore();
    for (let i = 0; i < delayStore.delayedMailItems.length; i++) {
        if (delayStore.delayedMailItems[i].data == data) {
            delayStore.delayedMailItems.splice(i, 1);
            break;
        }
    }
});
